import { gql } from "apollo-angular";

export class DrivingRestrictionMutations {
  public static createRestriction = gql`
    mutation CreateRestriction($restrictionDto: DrivingRestrictionDtoInput!) {
      drivingRestrictionCreateRestriction(restrictionDto: $restrictionDto)
    }
  `;

  public static editRestriction = gql`
    mutation EditRestriction($restrictionDto: DrivingRestrictionDtoInput!) {
      drivingRestrictionEditDrivingRestriction(restrictionDto: $restrictionDto)
    }
  `;

  public static deleteRestriction = gql`
    mutation DeleteRestriction($restrictionId: String!) {
      drivingRestrictionSoftDeleteDrivingRestriction(restrictionId: $restrictionId)
    }
  `;

  public static endRestriction = gql`
    mutation EndRestriction($restrictionId: String!) {
      drivingRestrictionEndRestriction(restrictionId: $restrictionId)
    }
  `;
}
